export const EDIT_RESET_PASSWORD = 'resetPasswordWithToken/EDIT_RESET_PASSWORD'
export const UPDATE_ERROR_MESSAGE = 'resetPasswordWithToken/UPDATE_ERROR_MESSAGE'
export const UPDATE_IS_RESET = 'resetPasswordWithToken/UPDATE_IS_RESET'
